import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";


import { SavesensorImport } from "../Reducers/actions";


import BedrijvenForm from "./Components/import";

const SensorInsertImport = ({ SavesensorImport, devices }) => {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const submit = async (vals) => {
    try {
      const data = await SavesensorImport(vals);
      if (data?.type === "SENSOR_ERROR") {
        alert(data.payload || "Er is een fout opgetreden bij het opslaan.");
      } else {
        navigate("/sensoren");
      }
    } catch (error) {
      console.error("Fout bij opslaan sensor:", error);
      alert("Opslaan mislukt. Probeer het later opnieuw.");
    }
  };

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Sensor importeren</h3>
      </div>

      <div className="row">
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile">
              <BedrijvenForm devices={devices} onSubmit={submit} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, {
  SavesensorImport,

})(SensorInsertImport);